<script>
/* eslint-disable */
import { mapGetters } from "vuex";
export default {
  name: "TableAnalytics",
  props: ["analytics"],
  methods: {
    getColour(progress) {
      if (progress <= 25) {
        return "red";
      }
      if (progress > 25 && progress <= 74) {
        return "yellow";
      }
      if (progress > 74) {
        return "green";
      }
    },
    getPercentage(data, denominator) {
      if (denominator == 0) {
        return 0;
      }
      let raw = (data / denominator) * 100;

      if (data >= denominator) {
        return 100;
      }

      if (raw % 1) {
        return raw.toPrecision(2);
      }
      return raw;
    },
    getTotal(data) {
      if (data.total_frequency == 0) return 0;
      let happily_motivated =
        (data.happily_motivated / data.total_frequency) * 100;
      if (happily_motivated >= 100) {
        happily_motivated = 100;
      }
      let calm_and_soothed =
        (data.calm_and_soothed / data.total_frequency) * 100;
      if (calm_and_soothed >= 100) {
        calm_and_soothed = 100;
      }
      let nurtured = (data.nurtured / data.total_frequency) * 100;
      if (nurtured >= 100) {
        nurtured = 100;
      }
      let pumper = (data.pumper / data.total_frequency) * 100;
      if (pumper >= 100) {
        pumper = 100;
      }

      let total =
        ((happily_motivated + calm_and_soothed + nurtured + pumper) / 300) *
        100;
      if (total % 1) {
        return total.toPrecision(2);
      }
      return total;
    },
  },
};
</script>
<style lang="scss">
.tooltip-wrapper {
  &.analytics {
    .data {
      width: 310px !important;
    }
  }
}
</style>
<template>
  <div>
    <h3 class="mt-3" v-if="!analytics">No results for this level</h3>

    <table v-if="analytics">
      <thead>
        <tr>
          <th>Benefit</th>
          <th>Happily Motivated</th>
          <th>Pumped</th>
          <th>Nurtured</th>
          <!-- <th>Calm and Soothed</th> -->
          <th>TOTAL</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in analytics" :key="index">
          <td>
            <div class="d-flex align-items-center">
              {{ index }}
            </div>
          </td>
          <td>
            <div class="d-flex align-items-center">
              <div class="tooltip-wrapper analytics">
                <span
                  >{{
                    getPercentage(item.happily_motivated, item.total_frequency)
                  }}%</span
                >
                <div class="data">
                  <p class="mb-0">
                    <b
                      >{{ item.happily_motivated }} live workouts out of
                      {{ item.total_frequency }} recommended</b
                    >
                  </p>
                  <p class="mb-0">during one cycle of this journey</p>
                </div>
              </div>

              <span class="progress-wrapper">
                <span
                  class="progress-status"
                  :class="
                    getColour(
                      getPercentage(
                        item.happily_motivated,
                        item.total_frequency
                      )
                    )
                  "
                  :style="{
                    width: `${getPercentage(
                      item.happily_motivated,
                      item.total_frequency
                    )}%`,
                  }"
                ></span>
              </span>
            </div>
          </td>
          <td>
            <div class="d-flex align-items-center">
              <div class="tooltip-wrapper analytics">
                <span
                  >{{ getPercentage(item.pumper, item.total_frequency) }}%</span
                >
                <div class="data">
                  <p class="mb-0">
                    <b
                      >{{ item.pumper }} live workouts out of
                      {{ item.total_frequency }} recommended</b
                    >
                  </p>
                  <p class="mb-0">during one cycle of this journey</p>
                </div>
              </div>
              <span class="progress-wrapper">
                <span
                  class="progress-status"
                  :class="
                    getColour(getPercentage(item.pumper, item.total_frequency))
                  "
                  :style="{
                    width: `${getPercentage(
                      item.pumper,
                      item.total_frequency
                    )}%`,
                  }"
                ></span>
              </span>
            </div>
          </td>
          <td>
            <div class="d-flex align-items-center">
              <div class="tooltip-wrapper analytics">
                <span
                  >{{
                    getPercentage(item.nurtured, item.total_frequency)
                  }}%</span
                >
                <div class="data">
                  <p class="mb-0">
                    <b
                      >{{ item.nurtured }} live workouts out of
                      {{ item.total_frequency }} recommended</b
                    >
                  </p>
                  <p class="mb-0">during one cycle of this journey</p>
                </div>
              </div>
              <span class="progress-wrapper">
                <span
                  class="progress-status"
                  :class="
                    getColour(
                      getPercentage(item.nurtured, item.total_frequency)
                    )
                  "
                  :style="{
                    width: `${getPercentage(
                      item.nurtured,
                      item.total_frequency
                    )}%`,
                  }"
                ></span>
              </span>
            </div>
          </td>
          <!-- <td>
            <div class="d-flex align-items-center">
              <div class="tooltip-wrapper analytics">
                <span
                  >{{
                    getPercentage(item.calm_and_soothed, item.total_frequency)
                  }}%</span
                >
                <div class="data">
                  <p class="mb-0">
                    <b
                      >{{ item.calm_and_soothed }} live workouts out of
                      {{ item.total_frequency }} recommended</b
                    >
                  </p>
                  <p class="mb-0">during one cycle of this journey</p>
                </div>
              </div>
              <span class="progress-wrapper">
                <span
                  class="progress-status"
                  :class="
                    getColour(
                      getPercentage(item.calm_and_soothed, item.total_frequency)
                    )
                  "
                  :style="{
                    width: `${getPercentage(
                      item.calm_and_soothed,
                      item.total_frequency
                    )}%`,
                  }"
                ></span>
              </span>
            </div>
          </td> -->
          <td>
            <div class="d-flex align-items-center">
              <div class="tooltip-wrapper analytics">
                <span>{{ getTotal(item) }}%</span>
              </div>
              <span class="progress-wrapper">
                <span
                  class="progress-status"
                  :class="getColour(getTotal(item))"
                  :style="{ width: `${getTotal(item)}%` }"
                ></span>
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>